
import { createContext, useContext, useState } from 'react';

interface LoginLogsContextType {
  totalRecords: number;
  setTotalRecords: (value: number) => void;
}

const LoginLogsContext = createContext<LoginLogsContextType | undefined>(undefined);

export const LoginLogsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  return (
    <LoginLogsContext.Provider value={{ totalRecords, setTotalRecords }}>
      {children}
    </LoginLogsContext.Provider>
  );
};

export const useLoginLogs = () => {
  const context = useContext(LoginLogsContext);
  if (context === undefined) {
    throw new Error('Login logs must be used within a LoginLogsProvider');
  }
  return context;
};